import { render } from "./RegionEdit.vue?vue&type=template&id=3478b393"
import script from "./RegionEdit.vue?vue&type=script&lang=js"
export * from "./RegionEdit.vue?vue&type=script&lang=js"

import "../../assets/style.css?vue&type=style&index=0&lang=css"

import exportComponent from "/builds/vidict/ott-platform/procricket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__